module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('sub-ibox-title', {
    attrs: {
      "is-show-back": false
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("商户中心")])]), _vm._v(" "), _c('z-tab-bar', {
    attrs: {
      "list-obj": _vm.tabBarParams.list,
      "active": _vm.tabBarParams.active
    },
    on: {
      "handleClickTabBar": _vm.handleClickTabBar
    }
  }), _vm._v(" "), _c('section', {}, [_c('info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'userCenter'),
      expression: "tabBarParams.active =='userCenter'"
    }]
  }), _vm._v(" "), _c('modify-pwd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabBarParams.active == 'modifPwd'),
      expression: "tabBarParams.active =='modifPwd'"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3c57ae1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/users/Index.vue
// module id = 831
// module chunks = 0